export default "__VITE_ASSET__rV1XwEGs__"